// HeroSection.js
import React from "react";

// 📝 Centralized Copy (Edit here only)
const heroCopy = {
    titleMain: "Reclaim. Restore.",
    titleHighlight: "Grow Your Wealth with",
    brandName: "Gantavyam.",
    lead:
        "We help families recover lost shares, transfer ownership to heirs, and reclaim investments from the IEPF to restore what’s rightfully theirs.",
    emphasis: "Expert guidance. Transparent process. Trusted results.",
    ctaPrimary: "Get in Touch",
    tagline: "Unlock the value of your lost or inherited wealth"
};

export default function Hero({
    onPrimaryClick = () => {
        const contactSection = document.getElementById("contact");
        if (contactSection) {
            contactSection.scrollIntoView({ behavior: "smooth" });
        }
    }
}) {
    return (
        <section
            id="hero"
            className="px-6 md:px-12 lg:px-20 py-14 md:py-20"
            aria-labelledby="hero-heading"
            style={{ backgroundColor: "var(--bg-surface)", color: "var(--text-primary)" }}
        >
            <div className="max-w-[900px] mx-auto text-left">
                <h1
                    id="hero-heading"
                    className="font-extrabold leading-tight tracking-tight text-[2.3rem] sm:text-[3.2rem] md:text-[4.2rem] lg:text-[5.2rem]"
                    style={{ lineHeight: 0.98, color: "var(--text-primary)" }}
                >
                    {heroCopy.titleMain} <br />
                    <span style={{ color: "var(--color-primary)" }}>
                        {heroCopy.titleHighlight}{" "}
                        <span className="text-[#e96a1e]">{heroCopy.brandName}</span>
                    </span>
                </h1>

                <p
                    className="mt-6 max-w-[72ch] text-base sm:text-lg md:text-[1.05rem] leading-relaxed"
                    style={{ color: "var(--text-secondary)" }}
                >
                    {heroCopy.lead}{" "}
                    <span className="font-semibold" style={{ color: "var(--text-primary)" }}>
                        {heroCopy.emphasis}
                    </span>{" "}
                    With {heroCopy.brandName.replace(".", "")} by your side, unlock the hidden value of your inheritance and investments.
                </p>

                <div className="mt-8 flex flex-wrap items-center gap-4">
                    <button
                        onClick={onPrimaryClick}
                        className="inline-flex items-center justify-center px-6 py-3 rounded-full text-sm md:text-base font-medium shadow-sm hover:translate-y-[-3px] transform transition"
                        style={{
                            backgroundColor: "var(--color-primary)",
                            color: "var(--bg-surface)"
                        }}
                    >
                        {heroCopy.ctaPrimary}
                    </button>

                    {/* Optional Secondary CTA (uncomment if needed)
          <a
            href="/services"
            className="inline-flex items-center justify-center px-6 py-3 rounded-full text-sm md:text-base font-medium hover:translate-y-[-2px] transition"
            style={{
              border: "2px solid var(--border)",
              color: "var(--text-primary)"
            }}
          >
            Explore Our Services
          </a>
          */}
                </div>

                <div className="mt-4 flex items-center gap-3">
                    <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        className="flex-none"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                        style={{ color: "var(--color-primary)" }}
                    >
                        <path d="M13 2L3 14h7l-1 8 10-12h-7l1-8z" fill="currentColor" />
                    </svg>

                    <span className="text-xs lg:text-sm italic" style={{ color: "var(--text-secondary)" }}>
                        {heroCopy.tagline}
                    </span>
                </div>
            </div>
        </section>
    );
}
